import React, { useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import { ThemeProvider, CssBaseline } from "@mui/material";
import { getThemeByMode } from "../static/styles/ThemeConfig";


export default function AppThemeProvider({ children }) {
  const { userPermissions } = useSelector((state) => state.userPermission);

  const mode = userPermissions?.appliedTheme || "default";

  const muiTheme = useMemo(() => getThemeByMode(mode), [mode]);

  // Keep data-theme attribute in sync for CSS variable fallback
  useEffect(() => {
    document.documentElement.setAttribute("data-theme", mode);
  }, [mode]);

  return (
    <ThemeProvider theme={muiTheme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
}
